// /* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login, selectAuth } from '../../features/authSlice';
import PageLoadAnimation from '../Loader/PageLoadAnimation';
import { LanguageSelector } from '../languageSelector/LanguageSelector';
import AdminMenu from './AdminMenu';
import Footer from './Footer';
import PublicPortalTopMenu from './PublicPortalTopMenu';
import UserMenu from './UserMenu';

const Layout = ({ children }) => {
  const ishomeee = useSelector((state) => state.toggle.isHome);
  // const { isAuthenticated, user } = useSelector((state) => state.auth);
  const { user, isAuthenticated } = useSelector(selectAuth);
  const [isHome, setIsHome] = useState();
  const [isAdmin, setAdmin] = useState(false);
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');

  useEffect(() => {
    const isHomeGetting = localStorage.getItem('isHome');
    setIsHome(isHomeGetting);
  }, []);

  useEffect(() => {
    if (token) {
      const sessionData = {};
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        const value = localStorage.getItem(key);
        sessionData[key] = value;
      }
      dispatch(login({ isAuthenticated: true, user: sessionData }));
    }
  }, [dispatch, token, user?.role]);

  useEffect(() => {
    if (user?.role === 'Admin') {
      setAdmin(true);
    }
  }, [user?.role]);

  return (
    <>
      <div className="h-screen flex flex-col justify-between	">
        <div>
          { isHome === 'true' && (
            <div >
              <PublicPortalTopMenu />
            </div>
          ) }
          { user?.role === 'Admin' && token && isHome === 'false' && (
            <div>
              <AdminMenu isAdmin={ isAdmin } isAuthenticated={ isAuthenticated } user={ user } />
            </div>
          ) }
          { user?.role === 'User' && token && isHome === 'false' && (
            <div>
              <UserMenu isAdmin={ isAdmin } isAuthenticated={ isAuthenticated } user={ user } />
            </div>
          ) }
          <div>
            <LanguageSelector />
            <main className="body-items ">{ children }</main>
          </div>
        </div>

        <div>
          <Footer />
        </div>
      </div>
      <PageLoadAnimation />
    </>
  );
};

export default Layout;


/* eslint-disable react/prop-types */
// import React, { useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { login, selectAuth } from '../../features/authSlice';
// import PageLoadAnimation from '../Loader/PageLoadAnimation';
// import { LanguageSelector } from '../languageSelector/LanguageSelector';
// import AdminMenu from './AdminMenu';
// import Footer from './Footer';
// import PublicPortalTopMenu from './PublicPortalTopMenu';
// import UserMenu from './UserMenu';

// const Layout = ({ children }) => {
//   const dispatch = useDispatch();
//   const { user, isAuthenticated } = useSelector(selectAuth);
//   const isHome = localStorage.getItem('isHome') === 'true';
//   const token = localStorage.getItem('token');
//   const userRole = user?.role;

//   useEffect(() => {
//     if (token) {
//       const sessionData = {};
//       Object.keys(localStorage).forEach((key) => {
//         sessionData[key] = localStorage.getItem(key);
//       });
//       dispatch(login({ isAuthenticated: true, user: sessionData }));
//     }
//   }, [dispatch, token]);

//   return (
//     <>
//       <div className="h-screen flex flex-col justify-between">
//         <div>
//           {isHome && <PublicPortalTopMenu />}

//           {!isHome && token && userRole === 'Admin' && (
//             <AdminMenu isAdmin user={user} isAuthenticated={isAuthenticated} />
//           )}

//           {!isHome && token && userRole === 'User' && (
//             <UserMenu isAdmin={false} user={user} isAuthenticated={isAuthenticated} />
//           )}

//           <LanguageSelector />
//           <main className="body-items">{children}</main>
//         </div>

//         <Footer />
//       </div>

//       <PageLoadAnimation />
//     </>
//   );
// };

// export default Layout;
